import classNames from 'classnames'
import React from 'react'

import { ReactComponent as HeroLogo } from '~/assets/hero-logo.svg'
import RichText from '~/components/rich-text'
import Title from '~/components/title'
import { animate } from '~/utils/animation'

import { IHeroSlideItems } from './block-main-hero'

interface Props extends IHeroSlideItems {
  titleTag: 'h1' | 'h2'
}

const MainHeroSliderItem: React.FC<Props> = ({
  description,
  showIcon,
  signIcon,
  title,
  titleTag,
}) => {
  return (
    <div className="container-small">
      <div className="max-w-[34.25rem]">
        <div className="relative w-fit">
          {showIcon && (
            <div className={classNames('absolute top-0 right-0', animate(4))}>
              <HeroLogo
                className={classNames(
                  'w-16 h-16 md:w-20 md:h-20 1.5xl:w-[6.25rem] 1.5xl:h-[6.25rem]',
                  {
                    '-translate-y-[65%] translate-x-[45%]': signIcon,
                    '-translate-y-[65%] translate-x-[85%]': !signIcon,
                  }
                )}
              />
            </div>
          )}
          <Title
            html={title}
            Tag={titleTag}
            className={classNames(
              'relative z-10 text-3xl md:text-5xl lg:text-7xl !leading-[0.9] text-neutral-white uppercase',
              animate(0)
            )}
          />
        </div>
        <RichText
          html={description}
          className={classNames(
            'text-neutral-white text-balance mt-4 1.5xl:mt-6',
            animate(1)
          )}
        />
      </div>
    </div>
  )
}

export default MainHeroSliderItem
